export const fPageview = () => {
  window.fbq?.("track", "PageView")
};
